import React, { useState } from 'react';
import './customer.css';
import CustomerModal from '../Modal/customerModal/CustomerModal';
import { useCustomerDetailsHideMutation, useMasterDetailsQuery } from '../../slices/Profile';
import { PopUp } from '../popup';

const Customer = () => {
  const { data: masterData, refetch: masterDataRefetch } = useMasterDetailsQuery();
  const [customerDetailsHide] = useCustomerDetailsHideMutation()
  const [addCustomerModal, setAddCustomerModal] = useState(false);
  const [editCustomerData, setEditCustomerData] = useState(null); // state to track customer being edited
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const handleAddCustomer = () => {
    setEditCustomerData(null); // reset the edit state
    setAddCustomerModal(true); // open modal
  };

  const handleEditCustomer = (customer) => {
    setEditCustomerData(customer); // set the customer data to edit
    setAddCustomerModal(true); // open modal
  };
  const handleHideCustomer =async (customer) => {
    const payload = {
      customer_id: customer?.customer_id
    }
    let res =await customerDetailsHide(payload)
    console.log(res);
    if(res?.data?.success){
      setPopupMessage(res?.data?.message);
      setIsSuccess(true);
      setShowPopup(true);
      masterDataRefetch()
    }else{
      setPopupMessage(res?.error?.data?.data?.error);
      setIsSuccess(true);
      setShowPopup(true);
    }
   
  }
  return (
    <div>
      <div className='customer_heading'>
        <h3>Customer Details</h3>
        <button onClick={handleAddCustomer}>Add Customer</button>
      </div>
      <div className="customer_card">
        {masterData && masterData?.data?.customers_data?.map((value, index) => (
          <div key={index} className="customer_card_data">
            <div className='edit_button'>
              <button onClick={() => handleHideCustomer(value)}>Hide</button>
              <button onClick={() => handleEditCustomer(value)}>Edit</button>
            </div>

            <div>
              <span className='customer_title'>Name: </span><span className='address_details'>{value?.cust_name}</span>
            </div>
            <div>
              <span className='customer_title'>Address: </span><span className='address_details'>{value?.cust_address}</span>
            </div>
            <div>
              <span className='customer_title'>Gstin: </span><span className='address_details'>{value?.gst_no}</span>
            </div>
          </div>
        ))}
      </div>
      {addCustomerModal && (
        <CustomerModal
          setAddCustomerModal={setAddCustomerModal}
          editCustomerData={editCustomerData}
          refetchMasterData={masterDataRefetch}
        />
      )}
      {showPopup && (
        <PopUp
          message={popupMessage}
          isSuccess={isSuccess}
          onClose={() => setShowPopup(false)}
        />
      )}
    </div>
  );
};

export default Customer;
